import { FilterParams } from "@/interfaces/filterParams";

const getDefaultFilterParams = (): FilterParams => ({
  user_ids: [],
  ai_feature_ids: [],
  cities: [],
  counties: [],
  states: [],
  organizations: [],
  channel_types: [],
  industry_ids: [],
  city_income: [-1, -1],
  county_income: [-1, -1],
  city_population: [-1, -1],
  county_population: [-1, -1],
});

export default getDefaultFilterParams;
